<div [class]="classes">
    <router-outlet></router-outlet>
</div>
